// extracted by mini-css-extract-plugin
export default {"recordIndicator":"RecordIndicator_recordIndicator__wkYLH","animated":"RecordIndicator_animated__6iLOE","pulse":"RecordIndicator_pulse__ftg-3"};